import { render, staticRenderFns } from "./AIDataReport.vue?vue&type=template&id=775db712&scoped=true"
import script from "./AIDataReport.vue?vue&type=script&lang=js"
export * from "./AIDataReport.vue?vue&type=script&lang=js"
import style0 from "./AIDataReport.vue?vue&type=style&index=0&id=775db712&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775db712",
  null
  
)

export default component.exports